import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  tone?: "light" | "dark";
}

export default function Breadcrumb({ items, tone = "light" }: BreadcrumbProps) {
  const base = tone === "light" ? "text-foreground-400" : "text-primary-300";
  const linkHover = tone === "light" ? "hover:text-primary-700" : "hover:text-accent-300";
  const current = tone === "light" ? "text-foreground-600" : "text-background-100";
  const divider = tone === "light" ? "text-foreground-300" : "text-primary-600";

  return (
    <nav aria-label="面包屑导航" className={`flex flex-wrap items-center gap-1.5 text-xs ${base}`}>
      <Link to="/" className={`transition-colors ${linkHover}`}>
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className={`ri-arrow-right-s-line ${divider}`} aria-hidden="true" />
          {item.to ? (
            <Link to={item.to} className={`transition-colors ${linkHover}`}>
              {item.label}
            </Link>
          ) : (
            <span className={current}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}